export default __webpack_public_path__ + "assets/viaurl.4b1f4d07498a9a7a6e95b1b7846a3299.png";